module.exports = __webpack_public_path__ + "video/3700_CT_2022_Conclusion.11abac90.vtt";